// Function to monitor for the modal appearing and set the first option
function setupSwymModalHandler() {
  // Create a MutationObserver to watch for the modal being added to the DOM
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const selectElement = document.getElementById('swym-remind-me-oos-options');
        if (selectElement) {
          console.log('Found select element, setting first option');
          
          // Set a small timeout to ensure the component is fully initialized
          setTimeout(function() {
            // Force select the first option
            selectElement.selectedIndex = 0;
            
            // Programmatically trigger change events
            const event = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(event);
            
            // Also try direct DOM interaction
            const firstOption = selectElement.querySelector('option:first-child');
            if (firstOption) {
              firstOption.selected = true;
            }
            
            console.log('First option set to:', selectElement.value);
          }, 50);
          
          // We can stop observing once we've found and set our select
          observer.disconnect();
          return;
        }
      }
    }
  });
  
  // Start observing the entire document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Add click handler to the notify button as an additional trigger
  const notifyButton = document.querySelector('.swym-add-to-watchlist');
  if (notifyButton) {
    notifyButton.addEventListener('click', function() {
      console.log('Notify button clicked');
      
      // Give the modal time to open
      setTimeout(function() {
        const selectElement = document.getElementById('swym-remind-me-oos-options');
        if (selectElement) {
          selectElement.selectedIndex = 0;
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 300);
    });
  }
}

// Set up the handler when the page loads
document.addEventListener('DOMContentLoaded', setupSwymModalHandler);

// Also set it up immediately in case the page is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setupSwymModalHandler();
}